// extracted by mini-css-extract-plugin
export var body = "_35-1";
export var bodyPadded = "_35-2";
export var chevron = "_35-4";
export var chevronOpen = "_35-5";
export var header = "_35-0";
export var icon = "_35-3";